<script lang="ts">
    import { getTierColor } from "$lib/utils/formatting";

    let {
        tier,
        size = "md",
        variant = "default",
    }: {
        tier: string;
        size?: "sm" | "md" | "lg";
        /** "banner" variant uses white text with heavy shadow for use on image headers. */
        variant?: "default" | "banner";
    } = $props();

    const sizeClass = $derived(size === "sm" ? "badge-sm text-xs" : size === "lg" ? "badge-lg" : "");
</script>

{#if variant === "banner"}
    <span
        class="badge {sizeClass} font-bold text-white text-shadow-banner"
        style="background-color: {getTierColor(tier)};"
    >
        {tier} Tier
    </span>
{:else}
    <span class="badge font-bold text-neutral {sizeClass}" style="background-color: {getTierColor(tier)};">
        {tier}
    </span>
{/if}
